/* eslint-disable @typescript-eslint/no-explicit-any */
import { OffersData } from '../OffersMBEHero.types';

export const getHeader = (
  variation: string,
  isUserLoggedIn: boolean,
  offersData: OffersData,
  offers: any,
  isMPOVar: boolean
) => {
  const titles = offersData?.hero || {};
  if (variation === 'active') {
    return isUserLoggedIn ? titles.authenticatedActiveTitle : isMPOVar ? offers.title : titles.anonymousActiveTitle;
  } else {
    return isUserLoggedIn ? titles.authenticatedInactiveTitle : titles.anonymousInactiveTitle;
  }
};

export const getDescription = (
  variation: string,
  isUserLoggedIn: boolean,
  offersData: OffersData,
  offers: any,
  isMPOVar: boolean
) => {
  const description = offersData?.hero || {};
  if (variation === 'active') {
    return isUserLoggedIn
      ? description.authenticatedActiveSubTitle
      : isMPOVar
      ? offers.description
      : description.anonymousActiveSubTitle;
  } else {
    return isUserLoggedIn ? description.authenticatedInactiveSubTitle : description.anonymousInactiveSubTitle;
  }
};

export const getMBEWrapperClass = (isUserLoggedIn: boolean, utilityState: string) => {
  return !isUserLoggedIn && utilityState === 'active' ? '' : 'mbeMessage-wrapper';
};
